/* eslint-disable no-unused-vars */
import React from "react";
import { Link } from "react-router-dom";
import MenuButton from "../MenuButton/MenuButton";
import { useContext, useEffect, useState } from "react";
import UserServices from "../../UserServices/UserServices";
import Swal from "sweetalert2/dist/sweetalert2.js";
import Pagination from "react-js-pagination";
import useSortableData from "../../hooks/useSortableData";
import useTable from "../../hooks/useTable";
import { NoteState } from "../../context/notes/NoteState";
import jsPDF from "jspdf";
import { toast } from "react-toastify";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

const LOGIN_IDS = [10317, 10321, 10253, 10406, 10130, 10354];
const OTHER_DESIGNATION_IDS = [117, 11]; // Partner, Electrician

const ViewTrainer = () => {
  const [loading, setLoading] = useState(false);
  const [myData, setMyData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState("100");
  const [clientType, setClientType] = useState("");
  const [totalResults, setTotalResults] = useState("0");
  const [totalPages, setTotalPages] = useState("1");
  const [exportLink, setExportLink] = useState("");
  const { state } = useContext(NoteState);
  const { branch_id, role, UId } = state;
  //adeel
  const [branchId, setBranchId] = useState('');
  console.log('checking btanch id', branchId);
  //adeel
  const [selectedOption, setSelectedOption] = useState("");
  // for inactive table
  const [inactiveLimit, setInactiveLimit] = useState("25");
  const [inactiveTotalResults, setInactiveTotalResults] = useState("0");
  const [inactiveTotalPages, setInactiveTotalPages] = useState("1");
  const [inactiveData, setInactiveData] = useState([]);
  const [myDepartment, setMyDepartment] = useState([]);
  //adeel
  const [myDesignation, setMyDesignation] = useState([]);

  const [myBranches, setMyBranches] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  //adeel
  const [selectedDesignation, setSelectedDesignation] = useState("");

  const [inactiveCurrentPage, setInactiveCurrentPage] = useState(1);
  const [tableLoading, setTableLoading] = useState(false);

  // New state for segregation
  const [departmentWiseData, setDepartmentWiseData] = useState({});
  const [designationWiseData, setDesignationWiseData] = useState({});
  const [viewMode, setViewMode] = useState('list'); // 'list', 'department', 'designation'
  const [showLogins, setShowLogins] = useState(false);

  // Function to group staff by department
  const groupStaffByDepartment = (staffData) => {
    const grouped = {};
    staffData.forEach((staff) => {
      const deptName = staff.department || 'Unassigned';
      if (!grouped[deptName]) {
        grouped[deptName] = [];
      }
      grouped[deptName].push(staff);
    });
    return grouped;
  };

  // Function to group staff by designation
  const groupStaffByDesignation = (staffData) => {
    const grouped = {};
    staffData.forEach((staff) => {
      const desigName = staff.designation || 'Unassigned';
      if (!grouped[desigName]) {
        grouped[desigName] = [];
      }
      grouped[desigName].push(staff);
    });
    return grouped;
  };

  const getUsers = async (page, limit) => {
    setTableLoading(true);
    setCurrentPage(page);
    let pageNo = page;

    let newLimit = limit;
    setLimit(newLimit);
    try {
      const responce = await UserServices.getactiveUsers(
        branchId,
        "1",
        newLimit,
        pageNo,
        selectedOption,
        selectedDepartment,
        selectedDesignation
      );
      let myDataarr;

      if (responce.status === 200) {
        setExportLink(
          process.env.REACT_APP_API_Link +
          "/auth/exportusers?status=1&branch_id=" +
          branchId
        );
        myDataarr = responce.data.data.data;
        // setMyData(...myDataarr); // removed generic spread which looked suspicious or was a no-op 
        const res = myDataarr;
        const results = [];
        res.map((value) => {
          results.push({
            id: value.id,
            branch_name: value.branch_name,
            first_name: value.first_name,
            father_name: value.father_name,
            department: value.department,
            designation: value.designation,
            designation_id: value.designation_id, // Added for filtering
            last_name: value.last_name,
            email: value.email,
            official_email: value.official_email,
            phone: value.phone,
            gender: value.gender,
            dob: value.dob,
            address: value.address,
            city: value.city,
            image: value.image,
          });
          return null;
        });
        setMyData([...results]);

        // Group staff by department and designation for views - EXCLUDING Login AND Other IDs
        const filteredForDept = results.filter(u => !LOGIN_IDS.includes(Number(u.id)) && !OTHER_DESIGNATION_IDS.includes(Number(u.designation_id)));
        const groupedData = groupStaffByDepartment(filteredForDept);
        setDepartmentWiseData(groupedData);

        const groupedDesignationData = groupStaffByDesignation(filteredForDept);
        setDesignationWiseData(groupedDesignationData);

        setLimit(responce.data.data.per_page);
        setTotalResults(responce.data.totalRecord);
        setTotalPages(responce.data.totalPages);
        setCurrentPage(responce.data.data.current_page);
        setTableLoading(false);
      }
    } catch (err) {
      if (err.response.status === 404) {
        setExportLink();
        setTotalResults("0");
        setTotalPages("1");
        setMyData([]);
        setMyData([]);
        setDepartmentWiseData({});
        setDesignationWiseData({});
        setTableLoading(false);
      } else {
        setTableLoading(false);
        setExportLink();
      }
    }
  };
  const getusersData = async (page, limit) => {
    setTableLoading(true);
    setInactiveCurrentPage(page);
    let pageNo = page;

    let newLimit = limit;
    setInactiveLimit(newLimit);
    try {
      const responce = await UserServices.getactiveUsers(
        branchId,
        "0",
        newLimit,
        pageNo
      );
      let myInactivedataarr;
      if (responce.status === 200) {
        myInactivedataarr = responce.data.data.data;

        const res = myInactivedataarr;
        const results = [];
        res.map((value) => {
          results.push({
            id: value.id,
            branch_name: value.branch_name,
            first_name: value.first_name,
            father_name: value.father_name,
            department: value.department,
            designation: value.designation,
            last_name: value.last_name,
            email: value.email,
            official_email: value.official_email,
            phone: value.phone,
            gender: value.gender,
            dob: value.dob,
            address: value.address,
            city: value.city,
            image: value.image,
          });
          return null;
        });
        setInactiveData([...results]);
        setInactiveLimit(responce.data.data.per_page);
        setInactiveTotalResults(responce.data.totalRecord);
        setInactiveTotalPages(responce.data.totalPages);
        setInactiveCurrentPage(responce.data.data.current_page);
        setTableLoading(false);
      }
    } catch (err) {
      setInactiveData([]);
      setTableLoading(false);
    }
  };
  const department = async () => {
    try {
      const responce = await UserServices.departmentName();
      const res = responce.data.data;
      const results = [];
      res.map((value) => {
        results.push({
          id: value.id,
          name: value.name,
        });
        return null;
      });
      setMyDepartment([{ name: "Select Department", id: "" }, ...results]);
    } catch (err) {
      console.log(err);
      setMyDepartment([]);
    }
  };

  //adeel
  const designation = async () => {
    try {
      const responce = await UserServices.designationName();
      const res = responce.data.data;
      const results = [];
      res.map((value) => {
        results.push({
          id: value.id,
          name: value.name,
        });
        return null;
      });
      setMyDesignation([{ name: "Select Designation", id: "" }, ...results]);
    } catch (err) {
      console.log(err);
      setMyDesignation([]);
    }
  };


  const branches = async () => {
    try {
      const responce = await UserServices.branchName();
      const res = responce.data.data;
      const results = [];

      res.map((value) => {
        results.push({
          id: value.id,
          name: value.name,
        });
        return null;
      });
      setMyBranches([{ name: "Select Branches", id: "" }, ...results]);
    } catch (err) {
    }
  };

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    getUsers(currentPage, limit);
    getusersData(inactiveCurrentPage, inactiveLimit);
    department();
    //adeel
    designation();
    branches();
    console.log("");

  }, [branchId, selectedOption, selectedDepartment, selectedDesignation]);



  const makeInActive = async (client_Id) => {
    try {
      setLoading(true);

      const responce = await UserServices.inactiveStaff(client_Id);

      if (responce.status === 204) {
        setLoading(false);

        toast.error("Inactive Successfully!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        getUsers(currentPage, limit);
        getusersData(inactiveCurrentPage, inactiveLimit);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const inactiveStaff = (client_Id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "Do you want to inactive this user?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6 ', // Red color with !important to override defaults
      cancelButtonColor: '#f44336 !important',
      confirmButtonText: 'Yes, inactive it!',
      cancelButtonText: 'Cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        makeInActive(client_Id);
        Swal.fire(
          'Inactive!',
          'The user has been inactive.',
          'success'
        );
      }
    });
  };



  const makeActive = async (client_id) => {
    try {
      setLoading(true);

      const responce = await UserServices.activeStaff(client_id);

      if (responce.status === 204) {
        setLoading(false);

        toast.success("Active Successfully!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        getUsers(currentPage, limit);
        getusersData(inactiveCurrentPage, inactiveLimit);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const activeStaff = (client_id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "Do you want to active this user? ",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6 ',
      cancelButtonColor: '#f44336 !important',
      confirmButtonText: 'Yes, active it!',
      cancelButtonText: 'Cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        makeActive(client_id);
        Swal.fire(
          'Active!',
          'The user has been active.',
          'success'
        );
      }
    });
  };

  const deleteRecord = async (user_id) => {
    try {
      const responce = await UserServices.deleteStaff(user_id);

      if (responce.status === 204) {
        toast.error("Deleted Successfully!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        getusersData(inactiveCurrentPage, inactiveLimit);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const delStaff = (user_id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this record ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ed1c24",
      cancelButtonColor: "#303030",
      confirmButtonText: "Yes, Delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteRecord(user_id);
      }
    });
  };
  const changeStaffType = (e) => {
    setSelectedOption(e);
    let staffType = e;
    setClientType(staffType);
    const getStaffData = async () => {
      setLoading(true);

      try {
        const responce = await UserServices.getactiveUsers(
          branchId,
          "1",
          limit,
          "1",
          staffType,
          selectedDepartment,
          selectedDesignation
        );
        console.log(responce);
        let myDataarr;

        if (responce.status === 200) {
          setExportLink(
            process.env.REACT_APP_API_Link +
            "/auth/exportusers?page=" +
            // 1 +
            "&status=1&limit=" +
            // limit +
            "&gender=" +
            staffType
          );
          myDataarr = responce.data.data.data;
          const res = myDataarr;
          const results = [];

          res.map((value) => {
            results.push({
              id: value.id,
              first_name: value.first_name,
              father_name: value.father_name,
              last_name: value.last_name,
              email: value.email,
              official_email: value.official_email,
              desigination: value.desigination,
              department: value.department,
              phone: value.phone,
              gender: value.gender,
              dob: value.dob,
              address: value.address,
              city: value.city,
              image: value.image,
            });
            return null;
          });

          setMyData([...results]);
          setTotalResults(responce.data.totalRecord);
          setTotalPages(responce.data.totalPages);
          setCurrentPage(responce.data.data.current_page);
          setLoading(false);
        }
      } catch (err) {
        if (err.response.status === 404) {
          setExportLink();
          setTotalResults("0");
          setTotalPages("1");
          setMyData([]);
          setLoading(false);
        } else {
          setLoading(false);
          setExportLink();
        }
      }
    };
    getStaffData();
  };
  const changeDepartment = (e) => {
    let staffType = e;
    setSelectedDepartment(e);
    const getStaffData = async () => {
      setLoading(true);

      try {
        const responce = await UserServices.getactiveUsers(
          branchId,
          "1",
          limit,
          "1",
          selectedOption,
          staffType
        );
        console.log(responce);
        let myDataarr;

        if (responce.status === 200) {
          setExportLink(
            process.env.REACT_APP_API_Link +
            "/auth/exportusers?page=" +
            // 1 +
            "&status=1&limit=" +
            // limit +
            "&depeartment_id=" +
            staffType
          );
          myDataarr = responce.data.data.data;
          const res = myDataarr;
          const results = [];

          res.map((value) => {
            results.push({
              id: value.id,
              first_name: value.first_name,
              father_name: value.father_name,
              last_name: value.last_name,
              email: value.email,
              official_email: value.official_email,
              desigination: value.desigination,
              department: value.department,
              phone: value.phone,
              gender: value.gender,
              dob: value.dob,
              address: value.address,
              city: value.city,
              image: value.image,
            });
            return null;
          });

          setMyData([...results]);
          setTotalResults(responce.data.totalRecord);
          setTotalPages(responce.data.totalPages);
          setCurrentPage(responce.data.data.current_page);
          setLoading(false);
        }
      } catch (err) {
        if (err.response.status === 404) {
          setExportLink();
          setTotalResults("0");
          setTotalPages("1");
          setMyData([]);
          setLoading(false);
        } else {
          setLoading(false);
          setExportLink();
        }
      }
    };
    getStaffData();
  };
  let searchTimer;

  const searchRecord = async (e) => {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(async () => {
      var search_name = e.target.value;
      setLoading(true);
      try {
        const response = await UserServices.staffNameSearch(
          search_name,
          branchId,
          "1",
          limit,
          1
        );
        let myDataarr;

        if (response.status === 200) {
          myDataarr = response.data.data.data;
          const res = myDataarr;
          const results = [];

          res.map((value) => {
            results.push({
              id: value.id,
              branch_name: value.branch_name,
              first_name: value.first_name,
              father_name: value.father_name,
              last_name: value.last_name,
              email: value.email,
              official_email: value.official_email,
              designation: value.designation,
              designation_id: value.designation_id, // Added for filtering
              department: value.department,
              phone: value.phone,
              gender: value.gender,
              dob: value.dob,
              address: value.address,
              city: value.city,
              image: value.image,
            });
            return null;
          });
          setMyData([...results]);

          // Update department-wise data for search results
          const filteredForDept = results.filter(u => !LOGIN_IDS.includes(Number(u.id)) && !OTHER_DESIGNATION_IDS.includes(Number(u.designation_id)));
          const groupedData = groupStaffByDepartment(filteredForDept);
          setDepartmentWiseData(groupedData);

          const groupedDesignationData = groupStaffByDesignation(filteredForDept);
          setDesignationWiseData(groupedDesignationData);

          setLimit(response.data.data.per_page);
          setTotalResults(response.data.totalRecord);
          setTotalPages(response.data.totalPages);
          setCurrentPage(response.data.data.current_page);

          setLoading(false);
        }
      } catch (err) {
        if (err.response?.status === 404) {
          setTotalResults("0");
          setTotalPages("1");
          setMyData([]);
          setLoading(false);
        } else {
          setLoading(false);
        }
      }
    }, 1000);
  };

  const generatePdf = () => {
    const doc = new jsPDF("p", "mm", "letter");
    const tableOptions = {
      headStyles: { fillColor: [232, 0, 43], textColor: 255 },
      styles: { fontSize: 7 },
      margin: { top: 20 },
    };

    if (viewMode === 'list') {
      const table = document.getElementById("report-POS");
      if (table) {
        const captionText = table.getAttribute("data-caption") || "All Active Staff";
        doc.text(captionText, 10, 10);
        doc.autoTable({
          html: table,
          ...tableOptions,
        });
      }
    } else {
      const dataMap = viewMode === 'department' ? departmentWiseData : designationWiseData;
      const titlePrefix = viewMode === 'department' ? 'Department: ' : 'Designation: ';
      let yPos = 10;

      doc.setFontSize(14);
      doc.text(`Staff List by ${viewMode === 'department' ? 'Department' : 'Designation'}`, 10, yPos);
      yPos += 10;

      if (Object.keys(dataMap).length > 0) {
        Object.entries(dataMap).forEach(([groupName, staffList]) => {
          if (yPos > 250) {
            doc.addPage();
            yPos = 10;
          }

          // Group Header
          doc.setFontSize(10);
          doc.setFont("helvetica", "bold");
          doc.text(`${titlePrefix}${groupName} (${staffList.length})`, 10, yPos);
          yPos += 5;

          // Table Body
          const body = staffList.map((el, index) => [
            index + 1,
            el.branch_name,
            `${el.first_name} ${el.last_name}`,
            viewMode === 'department' ? (el.designation || '') : (el.department || ''),
            el.father_name,
            `${el.email || "N/A"} / ${el.official_email || "N/A"}`,
            el.phone,
            el.gender,
            el.dob,
            el.city
          ]);

          doc.autoTable({
            head: [['Sr#', 'Branch', 'Name', viewMode === 'department' ? 'Designation' : 'Department', 'Father Name', 'Personal / Official Email', 'Phone', 'Gender', 'DOB', 'City']],
            body: body,
            startY: yPos,
            ...tableOptions,
            styles: { fontSize: 6 },
          });

          yPos = doc.lastAutoTable.finalY + 10;
        });
      }
    }
    doc.save("staff.pdf");
  };
  // Department Card Component
  const DepartmentCard = ({ departmentName, staffList }) => {
    return (
      <div className="card mb-4">
        <div className="card-header" style={{ backgroundColor: '#e8002b', color: 'white' }}>
          <h5 className="mb-0">
            <i className="bi bi-building"></i> {departmentName}
            <span className="badge bg-light text-dark ms-2">{staffList.length} Staff</span>
          </h5>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-striped table-borderless table-style-1">
              <thead>
                <tr>
                  <th scope="col">Sr#</th>
                  <th scope="col">Name</th>
                  <th scope="col">Father's Name</th>
                  <th scope="col">Branch</th>
                  <th scope="col">Designation</th>
                  <th scope="col">Personal / Official Email</th>
                  <th scope="col">Phone</th>
                  <th scope="col">Gender</th>
                  <th scope="col">DOB</th>
                  <th scope="col">Address</th>
                  <th scope="col">City</th>
                  {role === "1" || role === "3" || role === "12" ? (
                    <th scope="col">Action</th>
                  ) : null}
                  <th scope="col">Print Card</th>
                </tr>
              </thead>
              <tbody>
                {staffList.length ? (
                  staffList.map((el, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>
                        <div className="d-flex align-items-center">
                          <img
                            src={el.image || "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiNmOGY5ZmEiLz4KPHBhdGggZD0iTTIwIDEyQzIyLjIwOTEgMTIgMjQgMTMuNzkwOSAyNCAxNkMyNCAxOC4yMDkxIDIyLjIwOTEgMjAgMjAgMjBDMTcuNzkwOSAyMCAxNiAxOC4yMDkxIDE2IDE2QzE2IDEzLjc5MDkgMTcuNzkwOSAxMiAyMCAxMloiIGZpbGw9IiM5Y2E5YWIiLz4KPHBhdGggZD0iTTEyIDI4QzEyIDI0LjY4NjMgMTUuNjg2MyAyMSAyMCAyMUMyNC4zMTM3IDIxIDI4IDI0LjY4NjMgMjggMjhIMTJaIiBmaWxsPSIjOWNhOWFiIi8+Cjwvc3ZnPgo="}
                            alt={`${el.first_name} ${el.last_name}`}
                            className="staff-thumbnail me-2"
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "50%",
                              objectFit: "cover",
                              border: "2px solid #e8002b"
                            }}
                            onError={(e) => {
                              e.target.src = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiNmOGY5ZmEiLz4KPHBhdGggZD0iTTIwIDEyQzIyLjIwOTEgMTIgMjQgMTMuNzkwOSAyNCAxNkMyNCAxOC4yMDkxIDIyLjIwOTEgMjAgMjAgMjBDMTcuNzkwOSAyMCAxNiAxOC4yMDkxIDE2IDE2QzE2IDEzLjc5MDkgMTcuNzkwOSAxMiAyMCAxMloiIGZpbGw9IiM5Y2E5YWIiLz4KPHBhdGggZD0iTTEyIDI4QzEyIDI0LjY4NjMgMTUuNjg2MyAyMSAyMCAyMUMyNC4zMTM3IDIxIDI4IDI0LjY4NjMgMjggMjhIMTJaIiBmaWxsPSIjOWNhOWFiIi8+Cjwvc3ZnPgo=";
                            }}
                          />
                          <Link to={"/staff-profile/" + el.id}>
                            {el.first_name} {el.last_name}
                          </Link>
                        </div>
                      </td>
                      <td>{el.father_name}</td>
                      <td>{el.branch_name}</td>
                      <td>{el.designation}</td>
                      <td>{`${el.email || "N/A"} / ${el.official_email || "N/A"}`}</td>
                      <td>{el.phone}</td>
                      <td>{el.gender}</td>
                      <td>{el.dob}</td>
                      <td>{el.address}</td>
                      <td>{el.city}</td>
                      {role === "1" || role === "3" || role === "12" ? (
                        <td>
                          <button
                            type="button"
                            onClick={() => inactiveStaff(el.id)}
                            className="btn btn-sm btn-outline-danger"
                            disabled={UId === el.id}
                          >
                            <i className="bi bi-x-circle"></i> Inactive
                          </button>
                        </td>
                      ) : null}
                      <td>
                        <Link
                          className="btn btn-sm btn-outline-primary"
                          to={"/print-staff-card/" + el.id}
                        >
                          <i className="bi bi-printer"></i> Print
                        </Link>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="12" className="text-center">
                      No staff found in this department
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  };



  // Designation Card Component
  const DesignationCard = ({ designationName, staffList }) => {
    return (
      <div className="card mb-4">
        <div className="card-header" style={{ backgroundColor: '#28a745', color: 'white' }}>
          <h5 className="mb-0">
            <i className="bi bi-person-badge"></i> {designationName}
            <span className="badge bg-light text-dark ms-2">{staffList.length} Staff</span>
          </h5>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-striped table-borderless table-style-1">
              <thead>
                <tr>
                  <th scope="col">Sr#</th>
                  <th scope="col">Name</th>
                  <th scope="col">Father's Name</th>
                  <th scope="col">Branch</th>
                  <th scope="col">Department</th>
                  <th scope="col">Personal / Official Email</th>
                  <th scope="col">Phone</th>
                  <th scope="col">Gender</th>
                  <th scope="col">DOB</th>
                  <th scope="col">Address</th>
                  <th scope="col">City</th>
                  {role === "1" || role === "3" || role === "12" ? (
                    <th scope="col">Action</th>
                  ) : null}
                  <th scope="col">Print Card</th>
                </tr>
              </thead>
              <tbody>
                {staffList.length ? (
                  staffList.map((el, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>
                        <div className="d-flex align-items-center">
                          <img
                            src={el.image || "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiNmOGY5ZmEiLz4KPHBhdGggZD0iTTIwIDEyQzIyLjIwOTEgMTIgMjQgMTMuNzkwOSAyNCAxNkMyNCAxOC4yMDkxIDIyLjIwOTEgMjAgMjAgMjBDMTcuNzkwOSAyMCAxNiAxOC4yMDkxIDE2IDE2QzE2IDEzLjc5MDkgMTcuNzkwOSAxMiAyMCAxMloiIGZpbGw9IiM5Y2E5YWIiLz4KPHBhdGggZD0iTTEyIDI4QzEyIDI0LjY4NjMgMTUuNjg2MyAyMSAyMCAyMUMyNC4zMTM3IDIxIDI4IDI0LjY4NjMgMjggMjhIMTJaIiBmaWxsPSIjOWNhOWFiIi8+Cjwvc3ZnPgo="}
                            alt={`${el.first_name} ${el.last_name}`}
                            className="staff-thumbnail me-2"
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "50%",
                              objectFit: "cover",
                              border: "2px solid #e8002b"
                            }}
                            onError={(e) => {
                              e.target.src = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiNmOGY5ZmEiLz4KPHBhdGggZD0iTTIwIDEyQzIyLjIwOTEgMTIgMjQgMTMuNzkwOSAyNCAxNkMyNCAxOC4yMDkxIDIyLjIwOTEgMjAgMjAgMjBDMTcuNzkwOSAyMCAxNiAxOC4yMDkxIDE2IDE2QzE2IDEzLjc5MDkgMTcuNzkwOSAxMiAyMCAxMloiIGZpbGw9IiM5Y2E5YWIiLz4KPHBhdGggZD0iTTEyIDI4QzEyIDI0LjY4NjMgMTUuNjg2MyAyMSAyMCAyMUMyNC4zMTM3IDIxIDI4IDI0LjY4NjMgMjggMjhIMTJaIiBmaWxsPSIjOWNhOWFiIi8+Cjwvc3ZnPgo=";
                            }}
                          />
                          <Link to={"/staff-profile/" + el.id}>
                            {el.first_name} {el.last_name}
                          </Link>
                        </div>
                      </td>
                      <td>{el.father_name}</td>
                      <td>{el.branch_name}</td>
                      <td>{el.department}</td>
                      <td>{`${el.email || "N/A"} / ${el.official_email || "N/A"}`}</td>
                      <td>{el.phone}</td>
                      <td>{el.gender}</td>
                      <td>{el.dob}</td>
                      <td>{el.address}</td>
                      <td>{el.city}</td>
                      {role === "1" || role === "3" || role === "12" ? (
                        <td>
                          <button
                            type="button"
                            onClick={() => inactiveStaff(el.id)}
                            className="btn btn-sm btn-outline-danger"
                            disabled={UId === el.id}
                          >
                            <i className="bi bi-x-circle"></i> Inactive
                          </button>
                        </td>
                      ) : null}
                      <td>
                        <Link
                          className="btn btn-sm btn-outline-primary"
                          to={"/print-staff-card/" + el.id}
                        >
                          <i className="bi bi-printer"></i> Print
                        </Link>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="12" className="text-center">
                      No staff found in this designation
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  };

  const Table = ({ data, rowsPerPage }) => {
    const { slice } = useTable(data, 1, rowsPerPage);
    const { items, requestSort, sortConfig } = useSortableData(slice);

    const getClassNamesFor = (name) => {
      if (!sortConfig) {
        return;
      }
      return sortConfig.key === name ? sortConfig.direction : undefined;
    };

    return (
      <>
        {tableLoading ? (
          <SkeletonTheme height="40px">
            <Skeleton count={5} />
          </SkeletonTheme>
        ) : (
          <>
            <table
              className="table table-striped table-borderless table-style-1"
              id="report-POS"
              data-caption="All Active Staff"
            >
              <thead>
                <tr>
                  <th scope="col" className="no_sort">
                    Sr#
                  </th>
                  <th
                    scope="col"
                    onClick={() => requestSort("first_name")}
                    className={getClassNamesFor("first_name")}
                  >
                    Name
                  </th>
                  <th
                    scope="col"
                    onClick={() => requestSort("father_name")}
                    className={getClassNamesFor("father_name")}
                  >
                    Father Name
                  </th>

                  <th
                    scope="col"
                    onClick={() => requestSort("branch_name")}
                    className={getClassNamesFor("branch_name")}
                  >
                    Branch Name
                  </th>

                  <th
                    scope="col"
                    onClick={() => requestSort("desigination")}
                    className={getClassNamesFor("desigination")}
                  >
                    Designation
                  </th>
                  <th
                    scope="col"
                    onClick={() => requestSort("department")}
                    className={getClassNamesFor("department")}
                  >
                    Department
                  </th>
                  <th
                    scope="col"
                    onClick={() => requestSort("email")}
                    className={getClassNamesFor("email")}
                  >
                    Personal / Official Email
                  </th>
                  <th
                    scope="col"
                    onClick={() => requestSort("phone")}
                    className={getClassNamesFor("phone")}
                  >
                    Phone
                  </th>
                  <th
                    scope="col"
                    onClick={() => requestSort("gender")}
                    className={getClassNamesFor("gender")}
                  >
                    Gender
                  </th>
                  <th
                    scope="col"
                    onClick={() => requestSort("dob")}
                    className={getClassNamesFor("dob")}
                  >
                    DOB
                  </th>

                  <th
                    scope="col"
                    onClick={() => requestSort("address")}
                    className={getClassNamesFor("address")}
                  >
                    Address
                  </th>

                  <th
                    scope="col"
                    onClick={() => requestSort("city")}
                    className={getClassNamesFor("city")}
                  >
                    City
                  </th>
                  {role === "1" || role === "3" || role === "12" ? (
                    <th scope="col" className="no_sort">
                      Action
                    </th>
                  ) : null}
                  <th scope="col" className="no_sort">
                    Print Card
                  </th>
                </tr>
              </thead>
              <tbody>
                {items.length ? (
                  items.map((el, index) => (
                    <tr key={index}>
                      <td>
                        {currentPage === 1
                          ? index + 1
                          : (currentPage - 1) * limit + index + 1}
                      </td>
                      <td>
                        <div className="d-flex align-items-center">
                          <img
                            src={el.image || "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiNmOGY5ZmEiLz4KPHBhdGggZD0iTTIwIDEyQzIyLjIwOTEgMTIgMjQgMTMuNzkwOSAyNCAxNkMyNCAxOC4yMDkxIDIyLjIwOTEgMjAgMjAgMjBDMTcuNzkwOSAyMCAxNiAxOC4yMDkxIDE2IDE2QzE2IDEzLjc5MDkgMTcuNzkwOSAxMiAyMCAxMloiIGZpbGw9IiM5Y2E5YWIiLz4KPHBhdGggZD0iTTEyIDI4QzEyIDI0LjY4NjMgMTUuNjg2MyAyMSAyMCAyMUMyNC4zMTM3IDIxIDI4IDI0LjY4NjMgMjggMjhIMTJaIiBmaWxsPSIjOWNhOWFiIi8+Cjwvc3ZnPgo="}
                            alt={`${el.first_name} ${el.last_name}`}
                            className="staff-thumbnail me-2"
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "50%",
                              objectFit: "cover",
                              border: "2px solid #e8002b"
                            }}
                            onError={(e) => {
                              e.target.src = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiNmOGY5ZmEiLz4KPHBhdGggZD0iTTIwIDEyQzIyLjIwOTEgMTIgMjQgMTMuNzkwOSAyNCAxNkMyNCAxOC4yMDkxIDIyLjIwOTEgMjAgMjAgMjBDMTcuNzkwOSAyMCAxNiAxOC4yMDkxIDE2IDE2QzE2IDEzLjc5MDkgMTcuNzkwOSAxMiAyMCAxMloiIGZpbGw9IiM5Y2E5YWIiLz4KPHBhdGggZD0iTTEyIDI4QzEyIDI0LjY4NjMgMTUuNjg2MyAyMSAyMCAyMUMyNC4zMTM3IDIxIDI4IDI0LjY4NjMgMjggMjhIMTJaIiBmaWxsPSIjOWNhOWFiIi8+Cjwvc3ZnPgo=";
                            }}
                          />
                          <Link to={"/staff-profile/" + el.id}>
                            {el.first_name} {el.last_name}
                          </Link>
                        </div>
                      </td>
                      <td>{el.father_name}</td>
                      <td>{el.branch_name}</td>
                      <td>{el.designation}</td>
                      <td>{el.department}</td>
                      <td>{`${el.email || "N/A"} / ${el.official_email || "N/A"}`}</td>
                      <td>{el.phone}</td>
                      <td>{el.gender}</td>
                      <td>{el.dob}</td>
                      <td>{el.address}</td>
                      <td>{el.city}</td>

                      {role === "1" || role === "3" || role === "12" ? (
                        <td>
                          <button
                            type="button"
                            onClick={() => inactiveStaff(el.id)}
                            className=" inactive-btn"
                            disabled={UId === el.id}
                          >
                            <i className="bi bi-x-circle text-danger"></i>{" "}
                            <span className="text-danger inative-text ms-1">
                              Inactive
                            </span>
                          </button>
                        </td>
                      ) : null}

                      <td>
                        <Link
                          className="print-btn"
                          to={"/print-staff-card/" + el.id}
                        >
                          <i className="bi bi-printer"></i>{" "}
                          <span className="inative-text">Print Card</span>
                        </Link>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="14" className="text-center text-capitalize">
                      No record found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            {totalResults > limit && totalPages > 1 ? (
              <Pagination
                activePage={currentPage}
                itemsCountPerPage={parseInt(limit)}
                totalItemsCount={totalResults}
                onChange={(e) => {
                  getUsers(e, limit);
                }}
                pageRangeDisplayed={8}
                itemClass="page-item"
                linkClass="page-link"
                firstPageText="First Page"
                lastPageText="Last Page"
              />
            ) : (
              ""
            )}
          </>
        )}
      </>
    );
  };
  const InactiveTable = ({ data, rowsPerPage }) => {
    const { slice } = useTable(data, 1, rowsPerPage);
    const { items, requestSort, sortConfig } = useSortableData(slice);

    const getClassNamesFor = (name) => {
      if (!sortConfig) {
        return;
      }
      return sortConfig.key === name ? sortConfig.direction : undefined;
    };

    return (
      <>
        {tableLoading ? (
          <SkeletonTheme height="40px">
            <Skeleton count={5} />
          </SkeletonTheme>
        ) : (
          <>
            <table className="table table-striped table-borderless table-style-1">
              <thead>
                <tr>
                  <th scope="col" className="no_sort">
                    Sr#
                  </th>
                  <th
                    scope="col"
                    onClick={() => requestSort("first_name")}
                    className={getClassNamesFor("first_name")}
                  >
                    Name
                  </th>
                  <th
                    scope="col"
                    onClick={() => requestSort("father_name")}
                    className={getClassNamesFor("father_name")}
                  >
                    Father Name
                  </th>
                  <th
                    scope="col"
                    onClick={() => requestSort("branch_name")}
                    className={getClassNamesFor("branch_name")}
                  >
                    Branch Name
                  </th>

                  <th
                    scope="col"
                    onClick={() => requestSort("desigination")}
                    className={getClassNamesFor("desigination")}
                  >
                    Designation
                  </th>
                  <th
                    scope="col"
                    onClick={() => requestSort("department")}
                    className={getClassNamesFor("department")}
                  >
                    Department
                  </th>
                  <th
                    scope="col"
                    onClick={() => requestSort("email")}
                    className={getClassNamesFor("email")}
                  >
                    Personal / Official Email
                  </th>
                  <th
                    scope="col"
                    onClick={() => requestSort("phone")}
                    className={getClassNamesFor("phone")}
                  >
                    Phone
                  </th>

                  <th
                    scope="col"
                    onClick={() => requestSort("gender")}
                    className={getClassNamesFor("gender")}
                  >
                    Gender
                  </th>
                  <th
                    scope="col"
                    onClick={() => requestSort("dob")}
                    className={getClassNamesFor("dob")}
                  >
                    DOB
                  </th>
                  <th
                    scope="col"
                    onClick={() => requestSort("address")}
                    className={getClassNamesFor("address")}
                  >
                    Address
                  </th>
                  <th
                    scope="col"
                    onClick={() => requestSort("city")}
                    className={getClassNamesFor("city")}
                  >
                    City
                  </th>
                  {role === "1" || role === "3" || role === "12" ? (
                    <>
                      <th scope="col" className="no_sort">
                        Actions
                      </th>
                    </>
                  ) : null}
                </tr>
              </thead>
              <tbody>
                {items.length ? (
                  items.map((el, index) => (
                    <tr key={index}>
                      <td>
                        {inactiveCurrentPage === 1
                          ? index + 1
                          : (inactiveCurrentPage - 1) * inactiveLimit + index + 1}
                      </td>
                      <td>
                        <div className="d-flex align-items-center">
                          <img
                            src={el.image || "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiNmOGY5ZmEiLz4KPHBhdGggZD0iTTIwIDEyQzIyLjIwOTEgMTIgMjQgMTMuNzkwOSAyNCAxNkMyNCAxOC4yMDkxIDIyLjIwOTEgMjAgMjAgMjBDMTcuNzkwOSAyMCAxNiAxOC4yMDkxIDE2IDE2QzE2IDEzLjc5MDkgMTcuNzkwOSAxMiAyMCAxMloiIGZpbGw9IiM5Y2E5YWIiLz4KPHBhdGggZD0iTTEyIDI4QzEyIDI0LjY4NjMgMTUuNjg2MyAyMSAyMCAyMUMyNC4zMTM3IDIxIDI4IDI0LjY4NjMgMjggMjhIMTJaIiBmaWxsPSIjOWNhOWFiIi8+Cjwvc3ZnPgo="}
                            alt={`${el.first_name} ${el.last_name}`}
                            className="staff-thumbnail me-2"
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "50%",
                              objectFit: "cover",
                              border: "2px solid #e8002b"
                            }}
                            onError={(e) => {
                              e.target.src = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiNmOGY5ZmEiLz4KPHBhdGggZD0iTTIwIDEyQzIyLjIwOTEgMTIgMjQgMTMuNzkwOSAyNCAxNkMyNCAxOC4yMDkxIDIyLjIwOTEgMjAgMjAgMjBDMTcuNzkwOSAyMCAxNiAxOC4yMDkxIDE2IDE2QzE2IDEzLjc5MDkgMTcuNzkwOSAxMiAyMCAxMloiIGZpbGw9IiM5Y2E5YWIiLz4KPHBhdGggZD0iTTEyIDI4QzEyIDI0LjY4NjMgMTUuNjg2MyAyMSAyMCAyMUMyNC4zMTM3IDIxIDI4IDI0LjY4NjMgMjggMjhIMTJaIiBmaWxsPSIjOWNhOWFiIi8+Cjwvc3ZnPgo=";
                            }}
                          />
                          <Link to={"/staff-profile/" + el.id}>
                            {el.first_name} {el.last_name}
                          </Link>
                        </div>
                      </td>
                      <td>{el.father_name}</td>
                      <td>{el.branch_name}</td>
                      <td>{el.desigination}</td>
                      <td>{el.department}</td>
                      <td>{`${el.email || "N/A"} / ${el.official_email || "N/A"}`}</td>
                      <td>{el.phone}</td>
                      <td>{el.gender}</td>
                      <td>{el.dob}</td>
                      <td>{el.address}</td>
                      <td>{el.city}</td>
                      {role === "1" || role === "3" || role === "12" ? (
                        <>
                          <td>
                            <button
                              type="button"
                              onClick={() => activeStaff(el.id)}
                              className="active-btn"
                            >
                              <i className="bi bi-check-circle text-success"></i>{" "}
                              <span className="text-success inative-text ms-1">
                                Active
                              </span>
                            </button>
                            <button
                              type="button"
                              className=" inactive-btn ms-2"
                              onClick={() => delStaff(el.id)}
                            >
                              <i className="bi bi-trash3 text-danger"></i>{" "}
                              <span className="text-danger inative-text ms-1">
                                Delete
                              </span>
                            </button>
                          </td>
                        </>
                      ) : null}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="14" className="text-center text-capitalize">
                      No record found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            {inactiveTotalResults > inactiveLimit && inactiveTotalPages > 1 ? (
              <Pagination
                activePage={inactiveCurrentPage}
                itemsCountPerPage={parseInt(inactiveLimit)}
                totalItemsCount={inactiveTotalResults}
                onChange={(e) => {
                  getusersData(e, inactiveLimit);
                }}
                pageRangeDisplayed={8}
                itemClass="page-item"
                linkClass="page-link"
                firstPageText="First Page"
                lastPageText="Last Page"
              />
            ) : (
              ""
            )}
          </>
        )}
      </>
    );
  };
  // Separate users
  const loginUsers = myData.filter(user => LOGIN_IDS.includes(Number(user.id)));
  const otherUsers = myData.filter(user => OTHER_DESIGNATION_IDS.includes(Number(user.designation_id)) && !LOGIN_IDS.includes(Number(user.id)));
  const employeeUsers = myData.filter(user => !LOGIN_IDS.includes(Number(user.id)) && !OTHER_DESIGNATION_IDS.includes(Number(user.designation_id)));

  return (
    <>
      <div className="wrapper">
        <main className="page-content customer-contnent">
          <div className="site-main-design">
            <MenuButton />

            {/* Dashboard Tiles */}
            <div className="row mb-4">
              <div className="col-md-4">
                <div className="card text-white bg-primary mb-3 text-center">
                  <div className="card-body">
                    <h2 className="card-title display-4"><i className="bi bi-people-fill"></i> {totalResults}</h2>
                    <p className="card-text lead">Total Active Staff</p>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card text-white bg-info mb-3 text-center">
                  <div className="card-body">
                    <h2 className="card-title display-4"><i className="bi bi-shield-lock"></i> {loginUsers.length}</h2>
                    <p className="card-text lead">Total Logins</p>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card text-white bg-warning mb-3 text-center">
                  <div className="card-body">
                    <h2 className="card-title display-4"><i className="bi bi-person-badge"></i> {otherUsers.length}</h2>
                    <p className="card-text lead">Total Others</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="card">
              <div className="card-header py-3">
                <h5 className="mb-0 font-20">
                  Active Staff
                  <div className="float-end">
                    <div className="btn-group me-2" role="group">
                      <button
                        type="button"
                        className={`btn btn-sm ${viewMode === 'list' ? 'btn-success' : 'btn-outline-secondary'}`}
                        onClick={() => setViewMode('list')}
                      >
                        <i className="bi bi-list-ul"></i> List
                      </button>
                      <button
                        type="button"
                        className={`btn btn-sm ${viewMode === 'department' ? 'btn-success' : 'btn-outline-secondary'}`}
                        onClick={() => setViewMode('department')}
                      >
                        <i className="bi bi-building"></i> Dept
                      </button>
                      <button
                        type="button"
                        className={`btn btn-sm ${viewMode === 'designation' ? 'btn-success' : 'btn-outline-secondary'}`}
                        onClick={() => setViewMode('designation')}
                      >
                        <i className="bi bi-person-badge"></i> Desig
                      </button>
                    </div>
                    <button
                      type="button"
                      className={`btn btn-sm me-2 ${showLogins ? 'btn-info text-white' : 'btn-outline-info'}`}
                      onClick={() => setShowLogins(!showLogins)}
                    >
                      <i className={`bi ${showLogins ? 'bi-eye-slash' : 'bi-eye'}`}></i> {showLogins ? 'Hide Logins' : 'View Logins'}
                    </button>
                    <Link
                      to="/add-staff"
                      className="btn btn-primary d-inline-block btn-sm"
                    >
                      <i className="bi bi-plus" /> Add New Staff
                    </Link>
                  </div>
                </h5>
              </div>
              <div className="card-body">
                <div className="row mb-2">
                  <div className="col-md-2">
                    <div className="form-group custom-group">
                      <label className="form-label">Branch</label>
                      {myBranches ? (
                        <select
                          className="form-select"
                          name="branch_id"
                          // disabled={branch_id ? true : false}
                          value={branchId || ""}
                          onChange={(e) => {
                            const selectedBranch = e.target.value;
                            if (selectedBranch === "1") {
                              setBranchId(1);
                            } else if (selectedBranch === "15") {
                              setBranchId(15);
                            } else if (selectedBranch === "") {
                              setBranchId("");
                            }
                            getUsers(currentPage, limit);
                            getusersData(inactiveCurrentPage, inactiveLimit);
                          }}
                          style={{
                            borderRadius: "5px",
                            maxWidth: "150px",
                            maxHeight: "58px",
                          }}
                        >
                          {myBranches.map((el, index) => {
                            return (
                              <option key={index} value={el.id}>
                                {el.name}
                              </option>
                            );
                          })}
                        </select>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group custom-group">
                      <label className="form-label">Search By Name</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Name"
                        onChange={(e) => {
                          searchRecord(e);
                        }}
                      />
                    </div>
                  </div>

                  <div className="col-md-2 col-lg-2">
                    <div className="form-group custom-group">
                      <label className="form-label">Select Type</label>
                      <div className="input-group">
                        <select
                          className="form-select"
                          onChange={(e) => changeStaffType(e.target.value)}
                          value={selectedOption}
                        >
                          <option value="">Select Staff Type</option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                          <option value="Others">Others</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-2">
                    <div className="form-group custom-group">
                      <label className="form-label">Select Department</label>
                      {myDepartment.length ? (
                        <select
                          className="form-select"
                          name="select_department"
                          onChange={(e) => changeDepartment(e.target.value)}
                          value={selectedDepartment}
                        >
                          {myDepartment.map((el, index) => {
                            return (
                              <option key={index} value={el.id}>
                                {el.name}
                              </option>
                            );
                          })}
                        </select>
                      ) : (
                        <select className="form-select">
                          <option value="">Select Department</option>
                        </select>
                      )}
                    </div>
                  </div>
                  {/*adeel*/}
                  <div className="col-12 col-md-2">
                    <div className="form-group custom-group">
                      <label className="form-label">Select Designation</label>
                      {myDesignation.length ? (
                        <select
                          className="form-select"
                          name="select_designation"
                          onChange={(e) => setSelectedDesignation(e.target.value)}
                          value={selectedDesignation}
                        >
                          {myDesignation.map((el, index) => {
                            return (
                              <option key={index} value={el.id}>
                                {el.name}
                              </option>
                            );
                          })}
                        </select>
                      ) : (
                        <select className="form-select">
                          <option value="">Select Designation</option>
                        </select>
                      )}
                    </div>
                  </div>
                  {/*adeel*/}


                  {/* {totalResults > limit ? ( */}
                  <div className="col-md-1 col-lg-1 mt-4 ms-auto">
                    <div className="input-group">
                      <select
                        className="form-select"
                        value={limit}
                        onChange={(e) => getUsers("1", e.target.value)}
                      >
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="250">250</option>
                        <option value="500">500</option>
                      </select>
                    </div>
                  </div>
                  {/* ) : null} */}
                  <div className=" col-md-2 text-end mt-4">
                    <button
                      className="btn btn-primary mx-2 file-download"
                      onClick={() => {
                        generatePdf();
                      }}
                    >
                      <i className="bi bi-file-earmark-pdf"></i> PDF
                    </button>
                    <a
                      href={exportLink}
                      rel="noreferrer"
                      // target="_blank"
                      className="btn btn-primary mx-2 file-download"
                    >
                      <i className="bi bi-download" /> Excel
                    </a>
                  </div>
                </div>

                {/* Department-wise View */}
                {/* View Switching */}
                {viewMode === 'department' ? (
                  <div>
                    {Object.keys(departmentWiseData).length > 0 ? (
                      Object.entries(departmentWiseData).map(([departmentName, staffList]) => (
                        <DepartmentCard
                          key={departmentName}
                          departmentName={departmentName}
                          staffList={staffList}
                        />
                      ))
                    ) : (
                      <div className="text-center py-4">
                        <i className="bi bi-building text-muted" style={{ fontSize: '3rem' }}></i>
                        <h5 className="text-muted mt-3">No departments found</h5>
                        <p className="text-muted">No staff data available to group by department.</p>
                      </div>
                    )}
                  </div>
                ) : viewMode === 'designation' ? (
                  <div>
                    {Object.keys(designationWiseData).length > 0 ? (
                      Object.entries(designationWiseData).map(([designationName, staffList]) => (
                        <DesignationCard
                          key={designationName}
                          designationName={designationName}
                          staffList={staffList}
                        />
                      ))
                    ) : (
                      <div className="text-center py-4">
                        <i className="bi bi-person-badge text-muted" style={{ fontSize: '3rem' }}></i>
                        <h5 className="text-muted mt-3">No designations found</h5>
                        <p className="text-muted">No staff data available to group by designation.</p>
                      </div>
                    )}
                  </div>
                ) : (
                  /* Regular Table View */
                  <div className="table-responsive">
                    <Table data={employeeUsers} rowsPerPage={limit} />
                  </div>
                )}
              </div>
            </div>

            {/* Logins Section */}
            {showLogins && loginUsers.length > 0 && (
              <div className="card mb-3 mt-4">
                <div className="card-header py-3" style={{ backgroundColor: '#17a2b8', color: 'white' }}>
                  <h5 className="mb-0 font-20">
                    <i className="bi bi-shield-lock me-2"></i>
                    Logins
                  </h5>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-bordered table-striped mb-0">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Personal / Official Email</th>
                          <th>Branch</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loginUsers.map(user => (
                          <tr key={user.id}>
                            <td>{user.first_name} {user.last_name}</td>
                            <td>{user.father_name}</td>
                            <td>{`${user.email || "N/A"} / ${user.official_email || "N/A"}`}</td>
                            <td>{user.branch_name}</td>
                            <td>
                              <Link
                                to={`/staff-profile/${user.id}`}
                                className="btn btn-sm btn-primary"
                              >
                                <i className="bi bi-pencil-square me-1"></i> Edit
                              </Link>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}

            {/* Others Section */}
            {otherUsers.length > 0 && (
              <div className="card mb-3 mt-4">
                <div className="card-header py-3" style={{ backgroundColor: '#ffc107', color: 'black' }}>
                  <h5 className="mb-0 font-20">
                    <i className="bi bi-person-badge me-2"></i>
                    Others (Partners & Electricians)
                  </h5>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-bordered table-striped mb-0">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Father Name</th>
                          <th>Personal / Official Email</th>
                          <th>Branch</th>
                          <th>Designation</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {otherUsers.map(user => (
                          <tr key={user.id}>
                            <td>{user.first_name} {user.last_name}</td>
                            <td>{user.father_name}</td>
                            <td>{`${user.email || "N/A"} / ${user.official_email || "N/A"}`}</td>
                            <td>{user.branch_name}</td>
                            <td>{user.designation}</td>
                            <td>
                              <Link
                                to={`/staff-profile/${user.id}`}
                                className="btn btn-sm btn-primary"
                              >
                                <i className="bi bi-pencil-square me-1"></i> Edit
                              </Link>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}

            <div className="card">
              <div className="card-header py-3">
                <h5 className="mb-0 font-20">Inactive Staff</h5>
              </div>
              <div className="card-body">
                <div className="row">
                  {/* {totalResults > limit ? ( */}
                  <div className="col-md-1 col-lg-1 mb-2 ">
                    <div className="input-group">
                      <select
                        className="form-select"
                        value={inactiveLimit}
                        onChange={(e) => getusersData("1", e.target.value)}
                      >
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="250">250</option>
                        <option value="500">500</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="accordion-body">
                  <div className="table-responsive ">
                    <InactiveTable
                      data={inactiveData}
                      rowsPerPage={inactiveLimit}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
      <div className={`loader ${loading ? "in" : ""}`}>
        <div className="spinner-border main-spin"></div>
      </div>
    </>
  );
};

export default ViewTrainer;
